import React from "react";

import { useTranslation } from "react-i18next";

import { BulletinTextField } from "@/components/alerts/add-v2/fields/BulletinTextField";
import { useBulletinField } from "@/components/alerts/add-v2/state/bulletinFormContext";

/**
 * The bulletin description.
 *
 * Same single long-text field, same label and same required rule as today. Only its position moved:
 * after the entities, where it fills the live preview. The prototype's own annotation for this
 * section is "Narrative — unchanged", so the field is six rows with a prompt-style placeholder and
 * nothing else: the language toggle its `renderVals` carries is never rendered, and the design
 * review parked narrative-first entry with AI extraction (README section 2).
 *
 * The section subscribes to the original language only — the description itself is read and written
 * by the registered input, so typing in it does not re-render this component.
 */
export const NarrativeSection: React.FC = () => {
  const { t } = useTranslation("bulletin/create-v2");
  const [originalLanguage] = useBulletinField("originalLanguage");

  return (
    <BulletinTextField
      name={originalLanguage === "fr" ? "descriptionFr" : "description"}
      label={t("fields.narrative")}
      placeholder={t("fields.narrative_placeholder")}
      required
      fullWidth
      multiline
      minRows={6}
      // The label has to stay shrunk, or it sits on top of the placeholder.
      slotProps={{ inputLabel: { shrink: true } }}
    />
  );
};
